import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import { FavoriteIcon, FavoriteFilledIcon } from 'appSrc/v5/components/WildLifeIcons';
import { requestLikeList, requestLikeProduct, requestUnlikeList, requestUnlikeProduct,
    requestLikeArticle, requestUnlikeArticle, showModal } from 'appSrc/redux/actions';
import style from './styles/style.module.css';

class FavoriteBadge extends Component {
    determineLikeState = ( props ) => {
        var isAlreadyLiked = false;
        switch ( this.props.type ) {
            case 'list':
                isAlreadyLiked = props.ownLikedListIds.includes( props.item.listid );
                break;
            case 'product':
                isAlreadyLiked = props.ownLikedProductIds.includes( props.item.desireid );
                break;
            case 'article':
                isAlreadyLiked = props.ownLikedArticleIds.includes( props.item.id );
                break;
        }
        return isAlreadyLiked;
    }
    likeList = ( list ) => {
        this.props.likeList( list.listid )
        .then( ( response ) => {
            return Promise.resolve( this.props.onUpdate( response ) )
            .then( () => {
                var coverType = !!list.youtube ? 'video' : !!list.coverImage ? 'image' : 'none';
                var likes = !list.likes ? 0 : parseInt( list.likes );
                var views = !list.views ? 0 : parseInt( list.views );
                Mixpanel.track( 'listLiked', {
                    id: list.listid,
                    name: list.title,
                    user_id: list.userid,
                    date_created: list.dateCreated,
                    published: list.published,
                    like_count: likes,
                    // purchase_count: '?',
                    view_count: views,
                    // search_count: 0,
                    // share_count: 0,
                    cover_type: coverType,
                    author: list.userid,
                } );
            } );
        } );
    }
    likeArticle = ( article ) => {
        this.props.likeArticle( article.id )
        .then( ( response ) => {
            return Promise.resolve( this.props.onUpdate( response ) )
            .then( () => {
                var coverType = !!article.video_url ? 'video' : !!article.coverImage ? 'image' : 'none';
                var likes = !article.likes ? 0 : parseInt( article.likes );
                var views = !article.views ? 0 : parseInt( article.views );
                Mixpanel.track( 'articleLiked', {
                    id: article.id,
                    name: article.title,
                    user_id: article.userid,
                    date_created: article.dateCreated,
                    published: article.published,
                    like_count: likes,
                    view_count: views,
                    // search_count: 0,
                    // share_count: 0,
                    cover_type: coverType,
                    author: article.userid,
                } );
            } );
        } );
    }
    likeProduct = ( product ) => {
        this.props.likeProduct( product.desireid )
        .then( ( response ) => {
            return Promise.resolve( this.props.onUpdate( response ) )
            .then( () => {
                var retailer = /^(?:https?:\/\/)?([^\/\?\:]+)/.exec( product.originalUrl );
                var likes = !product.likes ? 0 : parseInt( product.likes );
                Mixpanel.track( 'productLiked', {
                    id: product.desireid,
                    name: product.title,
                    price: product.price,
                    retailer: retailer[1] || retailer[0],
                    // brand: '?',
                    date_created: product.dateCreated,
                    like_count: likes,
                    // purchase_count: 0,
                    // view_count: 0,
                    // search_count: 0,
                    // share_count: 0,
                    author: product.userid,
                    list: product.listid,
                } );
            } );
        } );
    }
    likeItem = () => {
        if( this.props.self.emailAddress === null ) {
            this.props.showLogin();
        } else {
            switch ( this.props.type ) {
                case 'list':
                    var list = this.props.item;
                    this.likeList( list );
                    break;
                case 'product':
                    var product = this.props.item;
                    this.likeProduct( product );
                    break;
                case 'article':
                    var article = this.props.item;
                    this.likeArticle( article );
                    break;
            }
        }
    }
    unlikeItem = () => {
        switch ( this.props.type ) {
            case 'list':
                this.props.unlikeList( this.props.item.listid )
                .then( ( response ) => {
                    return Promise.resolve( this.props.onUpdate( response ) );
                } );
                break;
            case 'product':
                this.props.unlikeProduct( this.props.item.desireid )
                .then( ( response ) => {
                    return Promise.resolve( this.props.onUpdate( response ) );
                } );
                break;
            case 'article':
                this.props.unlikeArticle( this.props.item.id )
                .then( ( response ) => {
                    return Promise.resolve( this.props.onUpdate( response ) );
                } );
                break;
        }
    }



    render() {
        const { showCount } = this.props;
        const isAlreadyLiked = this.determineLikeState( this.props );
        const className = `${ style.favoriteBadge } ${ this.props.className }`.trim();

        var likeCount = !this.props.item.likes ? 0 : parseInt( this.props.item.likes );

        return (
            <div style={ this.props.style } className={ className }
            data-liked={ isAlreadyLiked }
            title={ showCount ? `Likes: ${ likeCount }` : '' }
            onClick={ ()=>{ isAlreadyLiked ? this.unlikeItem() : this.likeItem(); } }>
                { isAlreadyLiked ?
                    <FavoriteFilledIcon />
                    :
                    <FavoriteIcon />
                }
                { this.props.label &&
                    <div className={ style.label }>{ this.props.label }</div>
                }
            </div>
        );
    }
}
FavoriteBadge.propTypes = {
    item: PropTypes.object.isRequired,
    //can probably cut out type and determine whether it's a product by whether the item has a desireid
    type: PropTypes.oneOf( [ 'list', 'product', 'article' ] ).isRequired,
    onUpdate: PropTypes.func,
    showCount: PropTypes.bool,
};
FavoriteBadge.defaultProps = {
    onUpdate: response => response,
    showCount: false,
    className: '',
};


const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        ownLikedListIds: state.self.likedListIds,
        ownLikedProductIds: state.self.likedProductIds,
        ownLikedArticleIds: state.self.likedArticleIds,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        likeList: ( listid ) => {
            return dispatch( requestLikeList( listid ) );
        },
        unlikeList: ( listid ) => {
            return dispatch( requestUnlikeList( listid ) );
        },
        likeProduct: ( productid ) => {
            return dispatch( requestLikeProduct( productid ) );
        },
        unlikeProduct: ( productid ) => {
            return dispatch( requestUnlikeProduct( productid ) );
        },
        likeArticle: ( articleId ) => {
            return dispatch( requestLikeArticle( articleId ) );
        },
        unlikeArticle: ( articleId ) => {
            return dispatch( requestUnlikeArticle( articleId ) );
        },
        showLogin: () => {
            dispatch( showModal( 'loginModal', { message: 'In order to follow, add, or like products, log into your account' } ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( FavoriteBadge );
